import React, { useState } from 'react';
import styled from '@emotion/styled';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { colors } from '../theme/colors';

const LegendContainer = styled.div`
  position: fixed;
  top: 120px;
  right: ${props => props.isOpen ? '16px' : '-128px'};
  background: ${props => props.isOpen ? 'white' : 'transparent'};
  border: ${props => props.isOpen ? '1px solid #e5e7eb' : 'none'};
  border-right: none;
  border-radius: 8px 0 0 8px;
  box-shadow: ${props => props.isOpen ? '-2px 0 8px rgba(0, 0, 0, 0.1)' : 'none'};
  transition: right 0.3s ease;
  z-index: 100;
  min-width: 180px;
`;

const LegendContent = styled.div`
  padding: 1rem;
  position: relative;
`;

const LegendTitle = styled.h4`
  margin: 0 0 0.75rem 0;
  font-size: 0.875rem;
  font-weight: 600;
  color: ${props => props.isOpen ? '#374151' : 'white'};
  display: flex;
  align-items: center;
  gap: 0.5rem;
  position: relative;
  
  &:focus {
    outline: none !important;
    box-shadow: none !important;
  }
  
  &:focus-visible {
    outline: none !important;
    box-shadow: none !important;
  }
`;

const ChevronBackground = styled.div`
  position: absolute;
  top: -1rem;
  right: -1rem;
  width: 40px;
  height: 40px;
  background: white;
  border: 1px solid #e5e7eb;
  border-right: none;
  border-radius: 8px 0 0 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: -2px 0 4px rgba(0, 0, 0, 0.1);
  z-index: 1;
  cursor: pointer;
  
  &:focus {
    outline: none !important;
    box-shadow: -2px 0 4px rgba(0, 0, 0, 0.1) !important;
  }
  
  &:focus-visible {
    outline: none !important;
    box-shadow: -2px 0 4px rgba(0, 0, 0, 0.1) !important;
  }
`;

const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

const LegendColor = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 3px;
  background: ${props => props.color};
  border: 1px solid rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
`;

const TitleText = styled.span`
  opacity: ${props => props.isOpen ? '1' : '0'};
  transition: opacity 0.3s ease;
`;

const LegendText = styled.span`
  font-size: 0.75rem;
  color: #6b7280;
  opacity: ${props => props.isOpen ? '1' : '0'};
  transition: opacity 0.3s ease;
`;

const CollapsibleLegend = () => {
  const [isOpen, setIsOpen] = useState(false);

  const legendItems = [
    { color: colors.success, label: 'High Match' },
    { color: colors.warning, label: 'Medium Match' },
    { color: colors.error, label: 'Low Match' },
    { color: '#d1d5db', label: 'No Match' }
  ];

  return (
    <LegendContainer isOpen={isOpen}>
      <LegendContent>
        <LegendTitle 
          isOpen={isOpen} 
          onClick={() => setIsOpen(!isOpen)} 
          style={{ cursor: 'pointer' }}
          tabIndex={0}
          onFocus={(e) => e.target.blur()}
        >
          {isOpen ? <ChevronRight size={16} /> : <ChevronLeft size={16} />}
          <TitleText isOpen={isOpen}>Match Status</TitleText>
        </LegendTitle>
        {legendItems.map((item, index) => (
          <LegendItem key={index}>
            <LegendColor color={item.color} />
            <LegendText isOpen={isOpen}>{item.label}</LegendText>
          </LegendItem>
        ))}
      </LegendContent>
    </LegendContainer>
  );
};

export default CollapsibleLegend;
